webpackJsonp([11],{

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(558)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(513),
  /* template */
  __webpack_require__(592),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 513:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_luxon__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['reportDetails'],
  data: function data() {
    return {
      report: {
        type: '',
        companyName: '',
        month: '',
        year: '',
        createdOn: '',
        modifiedOn: ''
      },
      headers: [{ text: this.$lang.header.webShopResourceId, value: 'webShopResourceId', align: 'left' }, { text: this.$lang.header.noOfOrders, value: 'noOfOrders', align: 'left' }, { text: this.$lang.header.ordersSum, value: 'ordersSum', align: 'left' }],
      paymentSummary: null
    };
  },

  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm');
    },
    calculatePaymentSummary: function calculatePaymentSummary(report) {
      var helper = {};
      this.paymentSummary = report.reduce(function (r, o) {
        var key = o.paymentType;

        if (!helper[key]) {
          helper[key] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, o);
          r.push(helper[key]);
        } else {
          helper[key].amount += o.amount;
        }

        return r;
      }, []);
    }
  },
  created: function created() {
    var _this = this;

    this.$http.get('report/' + this.reportDetails.id).then(function (res) {
      if (res.body.status === 'Success') {
        var report = res.body.report;
        report.createdOn = _this.formatDate(report.createdOn);
        report.modifiedOn = _this.formatDate(report.modifiedOn);
        _this.report = report;
        _this.calculatePaymentSummary(report.webShopResources.map(function (x) {
          return x.paymentSummary;
        }).flat(Infinity));
        return;
      }
      _this.err = res.body.statusText;
    }, function (err) {
      _this.err = err.body.statusText || err.body.message;
    });
  }
});

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(451)(true);
// imports


// module
exports.push([module.i, ".my-table thead th{padding:0 12px!important;opacity:.75!important}.my-table thead .topHeader{position:absolute;top:8px;font-size:15px;right:-48%;width:100%}.my-table thead .bottomHeader{padding:18px 24px 0!important}.my-table thead th:first-of-type{width:20px!important}.my-table{border:1px solid rgba(0,0,0,.12)!important}.my-table .customHeader{position:relative;padding:0!important}.my-table .customHeader td.bottomHeader{padding:18px 24px 0!important;display:block}.my-table thead tr:first-of-type{height:60px!important}.my-table-paymentSummary thead th:first-of-type{width:30px!important}.my-table-paymentSummary{border:1px solid rgba(0,0,0,.12)!important}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/modals/WebshopReportsModal.vue"],"names":[],"mappings":"AACA,mBACE,yBAA2B,AAC3B,qBAAwB,CACzB,AACD,2BACE,kBAAmB,AACnB,QAAS,AACT,eAAgB,AAChB,WAAY,AACZ,UAAY,CACb,AACD,8BACE,6BAAqC,CACtC,AACD,iCACE,oBAAuB,CACxB,AACD,UACE,0CAAiD,CAClD,AACD,wBACI,kBAAmB,AACnB,mBAAsB,CACzB,AACD,wCACM,8BAAqC,AACrC,aAAe,CACpB,AACD,iCACI,qBAAwB,CAC3B,AACD,gDACE,oBAAuB,CACxB,AACD,yBACE,0CAAiD,CAClD","file":"WebshopReportsModal.vue","sourcesContent":["\n.my-table thead th {\n  padding: 0 12px !important;\n  opacity: .75 !important;\n}\n.my-table thead .topHeader {\n  position: absolute;\n  top: 8px;\n  font-size: 15px;\n  right: -48%;\n  width: 100%;\n}\n.my-table thead .bottomHeader {\n  padding: 18px 24px 0 24px !important;\n}\n.my-table thead th:first-of-type {\n  width: 20px !important;\n}\n.my-table {\n  border: 1px solid rgba(0, 0, 0, 0.12) !important;\n}\n.my-table .customHeader {\n    position: relative;\n    padding: 0 !important;\n}\n.my-table .customHeader td.bottomHeader {\n      padding: 18px 24px 0 24px !important;\n      display: block;\n}\n.my-table thead tr:first-of-type {\n    height: 60px !important;\n}\n.my-table-paymentSummary thead th:first-of-type {\n  width: 30px !important;\n}\n.my-table-paymentSummary {\n  border: 1px solid rgba(0, 0, 0, 0.12) !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(532);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(452)("610ba4d3", content, true, {});

/***/ }),

/***/ 592:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-layout', {
    staticClass: "px-2 pt-4",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.type,
      "readonly": ""
    },
    model: {
      value: (_vm.report.type),
      callback: function($$v) {
        _vm.$set(_vm.report, "type", $$v)
      },
      expression: "report.type"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.companyName,
      "readonly": ""
    },
    model: {
      value: (_vm.report.companyName),
      callback: function($$v) {
        _vm.$set(_vm.report, "companyName", $$v)
      },
      expression: "report.companyName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.month,
      "readonly": ""
    },
    model: {
      value: (_vm.report.month),
      callback: function($$v) {
        _vm.$set(_vm.report, "month", $$v)
      },
      expression: "report.month"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.year,
      "readonly": ""
    },
    model: {
      value: (_vm.report.year),
      callback: function($$v) {
        _vm.$set(_vm.report, "year", $$v)
      },
      expression: "report.year"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.created,
      "readonly": ""
    },
    model: {
      value: (_vm.report.createdOn),
      callback: function($$v) {
        _vm.$set(_vm.report, "createdOn", $$v)
      },
      expression: "report.createdOn"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.modified,
      "readonly": ""
    },
    model: {
      value: (_vm.report.modifiedOn),
      callback: function($$v) {
        _vm.$set(_vm.report, "modifiedOn", $$v)
      },
      expression: "report.modifiedOn"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "px-4": "",
      "py-4": ""
    }
  }, [_c('hr')]), _vm._v(" "), _c('h3', {
    staticClass: "mx-4"
  }, [_vm._v(_vm._s(_vm.$lang.header.paymentSummary))]), _vm._v(" "), (_vm.paymentSummary) ? _c('v-data-table', {
    staticClass: "my-table-paymentSummary text-xs-left",
    attrs: {
      "items": _vm.paymentSummary,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', [_c('th', {
          staticClass: "text-xs-left ml-3"
        }, [_vm._v(_vm._s(_vm.$lang.header.paymentType))]), _vm._v(" "), _c('th', {
          staticClass: "text-xs-left ml-3"
        }, [_vm._v(_vm._s(_vm.$lang.header.amount))])])]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm.$lang.labels[props.item.paymentType]))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.amount))])]
      }
    }], null, false, 1371613615)
  }) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "mx-4 pt-4"
  }, [_vm._v(_vm._s(_vm.$lang.header.webShops))]), _vm._v(" "), _c('v-data-table', {
    staticClass: "my-table",
    attrs: {
      "items": _vm.report.webShopResources,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', [_c('th', {
          staticClass: "bottomHeader column text-xs-left"
        }, [_vm._v(_vm._s(_vm.$lang.header.webShopResourceId))]), _vm._v(" "), _c('th', {
          staticClass: "bottomHeader column text-xs-center"
        }, [_vm._v(_vm._s(_vm.$lang.header.paymentSummary))]), _vm._v(" "), _c('th', {
          staticClass: "customHeader"
        }, [_c('td', {
          staticClass: "topHeader"
        }, [_vm._v(_vm._s(_vm.$lang.header.webshop))]), _vm._v(" "), _c('td', {
          staticClass: "bottomHeader column text-xs-center",
          attrs: {
            "role": "columnheader",
            "scope": "col"
          }
        }, [_vm._v(_vm._s(_vm.$lang.license.orders))])]), _vm._v(" "), _c('th', {
          staticClass: "bottomHeader column",
          attrs: {
            "role": "columnheader",
            "scope": "col"
          }
        }, [_vm._v(_vm._s(_vm.$lang.license.totalAmount))]), _vm._v(" "), _c('th', {
          staticClass: "customHeader"
        }, [_c('td', {
          staticClass: "topHeader text-xs-center"
        }, [_vm._v(_vm._s(_vm.$lang.header.orderingApp))]), _vm._v(" "), _c('td', {
          staticClass: "bottomHeader column text-xs-center",
          attrs: {
            "role": "columnheader",
            "scope": "col"
          }
        }, [_vm._v(_vm._s(_vm.$lang.license.orders))])]), _vm._v(" "), _c('th', {
          staticClass: "bottomHeader column text-xs-center",
          attrs: {
            "role": "columnheader",
            "scope": "col"
          }
        }, [_vm._v(_vm._s(_vm.$lang.license.totalAmount))])])]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.webShopResourceId))]), _vm._v(" "), (props.item.paymentSummary) ? _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._l((props.item.paymentSummary), function(type) {
          return [_c('span', [_vm._v(_vm._s(_vm.$lang.labels[type.paymentType]) + ": " + _vm._s(type.amount))]), _c('br')]
        })], 2) : _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v("-")]), _vm._v(" "), (props.item.ordersData) ? _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.ordersData.webshop ? props.item.ordersData.webshop.noOfOrders : '-'))]) : _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v("-")]), _vm._v(" "), (props.item.ordersData) ? _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.ordersData.webshop ? props.item.ordersData.webshop.ordersSum : '-'))]) : _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v("-")]), _vm._v(" "), (props.item.ordersData) ? _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.ordersData['ordering app'] ? props.item.ordersData['ordering app'].noOfOrders : '-'))]) : _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v("-")]), _vm._v(" "), (props.item.ordersData) ? _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.ordersData['ordering app'] ? props.item.ordersData['ordering app'].ordersSum : '-'))]) : _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v("-")])]
      }
    }])
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-3",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n      " + _vm._s(_vm.$lang.actions.close) + "\n    ")], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/11.34a343d1e76bbd1e3db2.js